/* eslint-disable no-restricted-globals */
import { CHECK_EMAIL_REMINDER_PARAM } from "@components/collapsible-header/CollapsibleHeader";
import store from "src/utils/redux/store";
import { pushReroll, reroll, setParam } from "./utils";

function isEnrollment() {
  return location.pathname.startsWith("/enrollment");
}

function enrollmentBase(isHM: boolean) {
  return isHM ? "/enrollment-hm" : "/enrollment";
}

export const linkTo = {};

export default {
  enrollment({
    isHM,
    claimedByEmail,
    enrollmentResult,
    showEmailReminder,
    ...params
  }: {
    upid: string;
    name: string;
    email: string;
    claimedByEmail?: string;
    planId: string;
    route?: string;
    isHM?: boolean;
    enrollmentResult?: string;
    showEmailReminder?: boolean;
  }) {
    const state = store.getState();
    const languageCode = state.language;
    const countryCode = state.geoLocation.country_code;
    localStorage.setItem(
      "enrollmentData",
      JSON.stringify({
        ...params,
        lc: languageCode,
        cc: countryCode,
      })
    );

    const queryParams = new URLSearchParams();
    setParam(queryParams, "upid", params.upid);
    setParam(queryParams, "lc", languageCode);
    setParam(queryParams, "cc", countryCode);
    setParam(queryParams, "rerollMerEx", "true");

    const currentQueryParams = new URLSearchParams(location.search);
    setParam(queryParams, "route", currentQueryParams.get("route"));
    setParam(queryParams, "experiment", currentQueryParams.get("experiment"));
    setParam(
      queryParams,
      "claimedByEmail",
      claimedByEmail ?? currentQueryParams.get("claimedByEmail")
    );
    setParam(
      queryParams,
      "enrollmentResult",
      enrollmentResult ?? currentQueryParams.get("enrollmentResult")
    );
    setParam(queryParams, CHECK_EMAIL_REMINDER_PARAM, showEmailReminder);
    reroll(enrollmentBase(isHM), queryParams);
  },
  accountCreated(isHM: boolean, email: string) {
    pushReroll(
      `${enrollmentBase(isHM)}/account-created?email=${encodeURIComponent(
        email
      )}`,
      isEnrollment
    );
  },
};
